module.exports = __webpack_public_path__ + "Icon_Business Units Types.ea5a287a213a3cb54dee.png";